import Links from '@/shared/constants/navegacao';
import { DataTable } from '@/shared/components/tables/DataTable';
import { FindPersonFiltersDto } from '@/api.types.extra';
import { ReadPersonDto } from '@/api.types';
import { colunasGeral, colunasDefensor, colunasEstagiarios, colunasUsuarios, colunasColaboradores } from './index_columns';
import { readPerson } from '../../person.service';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useEffect, useMemo, useState } from 'react';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';

interface Props {
  tipo: 'todos' | 'defensor' | 'estagiario' | 'colaborador' | 'usuario'
}

export default function PersonIndexPage({ tipo }: Props) {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<[ReadPersonDto[], number]>();
  const tableState = useDataTableState("nome");

  const { titulo, colunas, createLink } = useMemo(() => {
    switch (tipo) {
      case 'colaborador':
        return {
          titulo: 'Colaboradores',
          colunas: colunasColaboradores,
          createLink: `${Links.Colaborador_Criar}`
        };
      case 'defensor':
        return {
          titulo: 'Defensores',
          colunas: colunasDefensor,
          createLink: `${Links.Defensor_Criar}`
        };
      case 'estagiario':
        return {
          titulo: 'Estagiários',
          colunas: colunasEstagiarios,
          createLink: `${Links.Estagiario_Criar}`
        };
      case 'usuario':
        return {
          titulo: 'Usuários',
          colunas: colunasUsuarios,
          createLink: `${Links.Usuario_Criar}`
        };
      default:
        return {
          titulo: 'Pessoas',
          colunas: colunasGeral,
          createLink: `${Links.Pessoa_Criar}`
        };
    }
  }, [tipo]);

  async function handleBuscar() {
    const filterCpf = tableState.filter && !isNaN(Number(tableState.filter)) ? tableState.filter : '';
    const filterNome = tableState.filter && isNaN(Number(tableState.filter)) ? tableState.filter : '';

    const filters: FindPersonFiltersDto = {
      skip: ((tableState.currentPage - 1) * tableState.pageSize),
      take: tableState.pageSize,
      nome: filterNome,
      cpf: filterCpf,
      comTelefone: true,

      comDefensor: tipo === 'defensor',
      isDefensor: tipo === 'defensor',

      comEstagiario: tipo === 'estagiario',
      isEstagiario: tipo === 'estagiario',
      comEstagios: tipo === 'estagiario',

      comUsuario: tipo === 'usuario',
      isUsuario: tipo === 'usuario',

      comColaborador: tipo === 'colaborador',
      isColaborador: tipo === 'colaborador',

      orderBy: tableState.sortConfig.direction,
    };

    try {
      const res = await readPerson(filters);
      setRegistros(res);
    } catch (error) {
      toast.error(String(error));
    }
  }

  useEffect(() => {
    handleBuscar();
  }, [tipo,
    tableState.currentPage,
    tableState.pageSize,
    tableState.filter,
    tableState.sortConfig?.key,
    tableState.sortConfig?.direction]);

  // Registra os botões no Breadcrumb (Ação Primária, Ação Secundária; sem listagem)
  useEffect(() => {
    const config = {
      primary: { label: 'Cadastrar', onClick: () => { }, href: createLink },
      ...(tipo === 'usuario' && { secondary: { label: 'Sessões', onClick: () => { }, href: Links.Sessoes_Index } }),
    };
    setActions(config);
    return () => setActions({});
  }, [setActions, createLink, tipo]);

  return (
    <div className="row">
      <div className="col-12">
        <h3 className="pt-4">{titulo}</h3>
        <span className="blockquote-footer pb-4 text-end">
          {titulo} cadastrados no sistema.
        </span>
      </div>

      <hr className="pb-4" />

      {registros &&
        <DataTable
          key={tipo}
          columns={colunas}
          data={registros?.[0]}
          initialSortKey="nome"
          onChange={handleBuscar}
          serverSide={true}
          states={tableState}
          totalRecords={registros?.[1]}
          renderFilters={() => (<></>)}
        />
      }
    </div>
  );
}